// NOTE: DISABLED UNTIL FURTHER NOTICE

// import * as angular from 'angular';
import * as _ from 'lodash';

type BypassValidator = (state: any) => boolean;

export class BeforeUnloadService {
    static readonly $inject = ['$window'];

    private state: string[];
    private bypass: BypassValidator;

    // constructor(private readonly window: angular.IWindowService) {
    //     // Bind to the onbeforeunload to alert users of unsaved changes
    //     this.window.onbeforeunload = this.warnUnsaved.bind(this);
    // }

    bypassWarning(bypass?: BypassValidator): void {
        this.bypass = bypass || (() => true);
    }

    getShowWarning(): boolean {
        if (this.state) {
            const values = _.values(this.state);
            const show = _.some(values, value => value);
            const bypass = this.bypass ? this.bypass(this.state) : false;

            return show && !bypass;
        }

        return false;
    }

    setState(state: any): void {
        this.state = state;
    }

    // private warnUnsaved(): string {
    //     const show = this.getShowWarning();
    //     if (show) {
    //         // Reset the flags to ensure further warnings are shown if current is cancelled
    //         this.bypass = null;

    //         // Return the warning message for the browser to show
    //         // Not that some browser will actually show their message - just need to make sure return value defined
    //         return 'You have attempted to leave this page with unsaved changes. Are you sure?';
    //     }

    //     return undefined;
    // }
}
